"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var MapMarker = function MapMarker() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    ariaHidden: "true",
    viewBox: "0 0 384 512"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    d: "M172.27 501.67C26.97 291.03 0 269.41 0 192 0 85.96 85.96 0 192 0s192 85.96 192 192c0 77.41-26.97 99.03-172.27 309.67a24.01 24.01 0 01-39.46 0zM192 272a80 80 0 100-160 80 80 0 000 160z"
  }));
};

var _default = MapMarker;
exports.default = _default;